var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-row',{staticClass:"navbar navbar-top bg-white no-gutters align-content-center justify-content-center"},[_c('d-col',{attrs:{"cols":"10"}},[_c('d-row',{staticClass:"align-items-center justify-content-end"},[_c('d-col',{attrs:{"cols":"auto"}},[_c('div',[_c('locale-select')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }